export default __webpack_public_path__ + "static/media/md.d04b7a63.PNG";